import styled from 'styled-components';

import { respondTo } from '../../common/styles/mixins';
import * as colors from '../../common/styles/colors';

export const HealthCheckStatusWrapper = styled.div`
  .healthCheckStatusDesktop {
    display: none;
    ${respondTo.tablet`
      display: flex;
      flex-direction: column;
      flex: 1;
    `};
  }

  .displayCenter {
    display: flex;
    margin: 0 auto;
  }

  .statusName {
    padding-left: 50px;
  }

  .displayName {
    padding-right: 50px;
  }

  .container {
    width: 60%;
    margin: 0px;
    padding-left: 0px;
  }

  .left {
    float: left;
    padding-right: 10px;
    width: 65%;
    ${respondTo.desktopXl`
      width: 75%;
    `};
  }

  .right {
    float: right;
    width: 35%;
    ${respondTo.desktopXl`
      width: 25%;
    `};
  }

  .unhealthyStatus {
    cursor: pointer;
    text-decoration: underline;
    display: inline;
  }

  .draxLogo {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 12;
  }
`;

export const HealthCheckStatusHeaderWrapper = styled.div`
  .healthyIcon {
    display: inline-block;
    vertical-align: middle;
  }

  .statusCount {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    padding-top: 40px;
  }
`;
